<template>
  <div class="home">
    <img src="/img/2019_PSU_SpringLifestyle_Drone_31.jpg">
    <p>Please select a form from the menu.</p>
  </div>
</template>

<script>
import _ from 'lodash'
import NavLinks from "@/components/NavLinks.vue"

export default {
  name: 'HomePage',
  
  components: { NavLinks },

  computed: {
    isAdmin() {
      var app_roles = this.$jwt.read(this.$appName).app_roles
      return app_roles && app_roles.indexOf("admin") >= 0
    },

    canProxy() {
      var jwt = this.$jwt.read(this.$appName)
      return jwt && jwt.app_roles && _.intersection(jwt.app_roles, this.$proxyRoles).length >= 0
    }
  }
}
</script>

<style scoped>
  img {
    width: 100%;
    height: auto;
  }

  p {
    margin-top: 1em;
    font-size: 1.5rem;
    text-align: center;
  }
</style>